import Fingerprint2 from 'fingerprintjs2';

/**
 * Class for working with Fingerprint.js lib.
 */
export default class Fingerprint {
  public generate(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(() => {
          this.getFingerprint()
            .then(hash => {
              resolve(hash);
            })
            .catch(() => {
              reject();
            });
        });
      } else {
        setTimeout(() => {
          this.getFingerprint()
            .then(hash => {
              resolve(hash);
            })
            .catch(() => {
              reject();
            });
        }, 500);
      }
    });
  }

  private getFingerprint(): Promise<string> {
    return new Promise(resolve => {
      Fingerprint2.get(
        {
          excludes: {
            timezone: true,
            timezoneOffset: true,
            addBehavior: true,
            plugins: true,
            adBlock: true,
            hasLiedLanguages: true,
            hasLiedResolution: true,
            hasLiedOs: true,
            hasLiedBrowser: true,
            fonts: true,
            fontsFlash: true,
            pixelRatio: true,
            screenResolution: true,
            availableScreenResolution: true,
            enumerateDevices: true
          }
        },
        components => {
          var values = components.map(function(component) {
            return component.value;
          });
          const hash = Fingerprint2.x64hash128(values.join(''), 31);
          resolve(hash);
        }
      );
    });
  }
}
